// File: src/components/BrandsList.js
import React from 'react';
import { List, Avatar, Typography, Space } from 'antd';
// import './BrandsList.css'; // Remove CSS import

const { Text } = Typography;

const BrandsList = ({ brands }) => {
    // Empty state is handled by the parent component (ShopDetailPage)
    if (!brands || brands.length === 0) {
        return null; // Render nothing if no brands are passed
    }

    return (
        <List
            grid={{
                gutter: 16, // Space between items
                xs: 2,      // 2 columns on extra small screens
                sm: 3,      // 3 columns on small screens
                md: 4,      // 4 columns on medium screens
                lg: 5,      // 5 columns on large screens
                xl: 6,      // 6 columns on extra large screens
                xxl: 6,     // 6 columns on extra extra large screens
            }}
            dataSource={brands}
            renderItem={(brand, index) => (
                <List.Item key={index}>
                    <Space>
                        <Avatar 
                            size="small" 
                            style={{ backgroundColor: '#1890ff' }} // Example background color
                        >
                            {brand.charAt(0).toUpperCase()}
                        </Avatar>
                        <Text>{brand}</Text>
                    </Space>
                </List.Item>
            )}
        />
    );
};

export default BrandsList;